var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.telemetry.truck.brand.id},[_vm._t("default",null,null,{ skinData: _vm.skinData(), currentScale: _vm.currentScale })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }